export enum Mode {
    View,
    Scene,
    AreaOfReview,
    Route
}
